import React, { useState, useEffect } from 'react'
import { Box, Typography, Chip, Paper, IconButton, Tooltip, Collapse } from '@material-ui/core'
import { ExpandMore, ExpandLess, CheckCircle as ReceivedIcon } from '@material-ui/icons'
import axios from 'axios'

const statusColor = {
  draft: '#9e9e9e',
  sent: '#1976d2',
  received: '#4caf50',
  failed: '#d32f2f'
}

const VendorRequestsPanel = ({ projectId, url }) => {
  const [requests, setRequests] = useState([])
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (!projectId || !url) return
    axios.get(`${url}/api/bid-estimation/projects/${projectId}/vendor-requests`)
      .then(res => setRequests(res.data || []))
      .catch(console.error)
  }, [projectId, url])

  const handleMarkReceived = async (requestId) => {
    try {
      await axios.put(`${url}/api/bid-estimation/vendor-requests/${requestId}/status`, {
        status: 'received'
      })
      setRequests(prev => prev.map(r =>
        r._id === requestId ? { ...r, status: 'received', response: { ...r.response, receivedAt: new Date() } } : r
      ))
    } catch (err) {
      console.error(err)
    }
  }

  if (requests.length === 0) return null

  return (
    <Paper variant="outlined" style={{ marginTop: 16 }}>
      <Box
        p={1.5}
        display="flex"
        alignItems="center"
        style={{ cursor: 'pointer' }}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? <ExpandLess /> : <ExpandMore />}
        <Typography variant="subtitle2" style={{ fontWeight: 600, marginLeft: 8 }}>
          Vendor Requests ({requests.length})
        </Typography>
      </Box>
      <Collapse in={expanded}>
        <Box px={2} pb={2}>
          {requests.map(r => (
            <Box
              key={r._id}
              display="flex"
              alignItems="center"
              style={{ gap: 8, padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}
            >
              <Chip
                size="small"
                label={r.status}
                style={{
                  backgroundColor: statusColor[r.status] || '#9e9e9e',
                  color: '#fff',
                  fontSize: 10,
                  height: 20,
                  width: 65
                }}
              />
              <Typography variant="body2" style={{ fontWeight: 500, flex: 1 }}>
                {r.vendorName}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {(r.requestedScopes || []).join(', ')}
              </Typography>
              <Typography variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
                {r.sentAt ? new Date(r.sentAt).toLocaleDateString() : ''}
              </Typography>
              {r.status === 'sent' && (
                <Tooltip title="Mark as received">
                  <IconButton size="small" onClick={() => handleMarkReceived(r._id)}>
                    <ReceivedIcon fontSize="small" style={{ color: '#4caf50' }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          ))}
        </Box>
      </Collapse>
    </Paper>
  )
}

export default VendorRequestsPanel
